export default __webpack_public_path__ + "static/media/Pict4.ed6167ce.png";